import { useIsMobile } from "src/hooks/useIsMobile";
import MobileMessagingThread from "./components/MobileMessagingThread";
import DesktopMessagingThread from "./components/DesktopMessagingThread";

const MessagingThread = () => {
  const isMobile = useIsMobile();
  const page = "messaging";

  return isMobile ? (
    <MobileMessagingThread data-testid="message-thread" page={page} />
  ) : (
    <DesktopMessagingThread data-testid="message-thread" page={page} />
  );
};

export default MessagingThread;
